/* eslint-disable */
import * as Types from './types';

import { ServerError } from "../fetcher";

import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher';

export const SubscribeErecoDocument = `
    mutation subscribeEreco($accountId: ID!, $customerId: ID!) {
  subscribeEreco(accountId: $accountId, customerId: $customerId)
}
    `;
export const useSubscribeErecoMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.SubscribeErecoMutation, TError, Types.SubscribeErecoMutationVariables, TContext>) =>
    useMutation<Types.SubscribeErecoMutation, TError, Types.SubscribeErecoMutationVariables, TContext>(
      ['subscribeEreco'],
      (variables?: Types.SubscribeErecoMutationVariables) => fetcher<Types.SubscribeErecoMutation, Types.SubscribeErecoMutationVariables>(SubscribeErecoDocument, variables)(),
      options
    );
useSubscribeErecoMutation.fetcher = (variables: Types.SubscribeErecoMutationVariables, options?: RequestInit['headers']) => fetcher<Types.SubscribeErecoMutation, Types.SubscribeErecoMutationVariables>(SubscribeErecoDocument, variables, options);
export const LoginCheckDocument = `
    query LoginCheck($login: String!) {
  loginCheck(login: $login) {
    __typename
    ... on TemporaryLoginResponse {
      redirectUrl
      anonymizedEmail
      token
      agencyEmail
      agencyPhone
    }
    ... on PermanentLoginResponse {
      isLoginWithOktaEnabled
    }
  }
}
    `;
export const useLoginCheckQuery = <
      TData = Types.LoginCheckQuery,
      TError = ServerError
    >(
      variables: Types.LoginCheckQueryVariables,
      options?: UseQueryOptions<Types.LoginCheckQuery, TError, TData>
    ) =>
    useQuery<Types.LoginCheckQuery, TError, TData>(
      ['LoginCheck', variables],
      fetcher<Types.LoginCheckQuery, Types.LoginCheckQueryVariables>(LoginCheckDocument, variables),
      options
    );

useLoginCheckQuery.getKey = (variables: Types.LoginCheckQueryVariables) => ['LoginCheck', variables];
;

export const useInfiniteLoginCheckQuery = <
      TData = Types.LoginCheckQuery,
      TError = ServerError
    >(
      variables: Types.LoginCheckQueryVariables,
      options?: UseInfiniteQueryOptions<Types.LoginCheckQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.LoginCheckQuery, TError, TData>(
      ['LoginCheck.infinite', variables],
      (metaData) => fetcher<Types.LoginCheckQuery, Types.LoginCheckQueryVariables>(LoginCheckDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteLoginCheckQuery.getKey = (variables: Types.LoginCheckQueryVariables) => ['LoginCheck.infinite', variables];
;

useLoginCheckQuery.fetcher = (variables: Types.LoginCheckQueryVariables, options?: RequestInit['headers']) => fetcher<Types.LoginCheckQuery, Types.LoginCheckQueryVariables>(LoginCheckDocument, variables, options);
export const GetBrandDocument = `
    query GetBrand($code: String!) {
  brand(code: $code) {
    __typename
    ... on QueryBrandSuccess {
      data {
        id
        code
        identity {
          name
          logoUrl
        }
        dataProtectionPolicy {
          email
          url
        }
        customerPortal {
          name
          url
          displayUrl
          logoUrl
          assistance {
            phone
            hours
          }
          guides {
            userGuides {
              categoryName
              documents {
                url
                originalFilename
                mimeType
                qualities
              }
            }
            propertyTaxFillingGuide {
              url
              originalFilename
              mimeType
              qualities
            }
          }
        }
        registeredEmailService {
          name
        }
        payment {
          hasAutomaticDirectDebit
          hasOnDemandDirectDebit
        }
      }
    }
    ... on BrandNotFoundError {
      message
      code
    }
    ... on Error {
      message
    }
  }
}
    `;
export const useGetBrandQuery = <
      TData = Types.GetBrandQuery,
      TError = ServerError
    >(
      variables: Types.GetBrandQueryVariables,
      options?: UseQueryOptions<Types.GetBrandQuery, TError, TData>
    ) =>
    useQuery<Types.GetBrandQuery, TError, TData>(
      ['GetBrand', variables],
      fetcher<Types.GetBrandQuery, Types.GetBrandQueryVariables>(GetBrandDocument, variables),
      options
    );

useGetBrandQuery.getKey = (variables: Types.GetBrandQueryVariables) => ['GetBrand', variables];
;

export const useInfiniteGetBrandQuery = <
      TData = Types.GetBrandQuery,
      TError = ServerError
    >(
      variables: Types.GetBrandQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetBrandQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetBrandQuery, TError, TData>(
      ['GetBrand.infinite', variables],
      (metaData) => fetcher<Types.GetBrandQuery, Types.GetBrandQueryVariables>(GetBrandDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetBrandQuery.getKey = (variables: Types.GetBrandQueryVariables) => ['GetBrand.infinite', variables];
;

useGetBrandQuery.fetcher = (variables: Types.GetBrandQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetBrandQuery, Types.GetBrandQueryVariables>(GetBrandDocument, variables, options);
export const GetInsuranceCompaniesDocument = `
    query GetInsuranceCompanies {
  insuranceCompanies
}
    `;
export const useGetInsuranceCompaniesQuery = <
      TData = Types.GetInsuranceCompaniesQuery,
      TError = ServerError
    >(
      variables?: Types.GetInsuranceCompaniesQueryVariables,
      options?: UseQueryOptions<Types.GetInsuranceCompaniesQuery, TError, TData>
    ) =>
    useQuery<Types.GetInsuranceCompaniesQuery, TError, TData>(
      variables === undefined ? ['GetInsuranceCompanies'] : ['GetInsuranceCompanies', variables],
      fetcher<Types.GetInsuranceCompaniesQuery, Types.GetInsuranceCompaniesQueryVariables>(GetInsuranceCompaniesDocument, variables),
      options
    );

useGetInsuranceCompaniesQuery.getKey = (variables?: Types.GetInsuranceCompaniesQueryVariables) => variables === undefined ? ['GetInsuranceCompanies'] : ['GetInsuranceCompanies', variables];
;

export const useInfiniteGetInsuranceCompaniesQuery = <
      TData = Types.GetInsuranceCompaniesQuery,
      TError = ServerError
    >(
      variables?: Types.GetInsuranceCompaniesQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetInsuranceCompaniesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetInsuranceCompaniesQuery, TError, TData>(
      variables === undefined ? ['GetInsuranceCompanies.infinite'] : ['GetInsuranceCompanies.infinite', variables],
      (metaData) => fetcher<Types.GetInsuranceCompaniesQuery, Types.GetInsuranceCompaniesQueryVariables>(GetInsuranceCompaniesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetInsuranceCompaniesQuery.getKey = (variables?: Types.GetInsuranceCompaniesQueryVariables) => variables === undefined ? ['GetInsuranceCompanies.infinite'] : ['GetInsuranceCompanies.infinite', variables];
;

useGetInsuranceCompaniesQuery.fetcher = (variables?: Types.GetInsuranceCompaniesQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetInsuranceCompaniesQuery, Types.GetInsuranceCompaniesQueryVariables>(GetInsuranceCompaniesDocument, variables, options);
export const UpdateHeatingCertificateDocument = `
    mutation updateHeatingCertificate($customerId: ID!, $heatingCertificate: UpdateLeaseHeatingCertificateInput!) {
  updateHeatingCertificate(
    customerId: $customerId
    heatingCertificate: $heatingCertificate
  )
}
    `;
export const useUpdateHeatingCertificateMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.UpdateHeatingCertificateMutation, TError, Types.UpdateHeatingCertificateMutationVariables, TContext>) =>
    useMutation<Types.UpdateHeatingCertificateMutation, TError, Types.UpdateHeatingCertificateMutationVariables, TContext>(
      ['updateHeatingCertificate'],
      (variables?: Types.UpdateHeatingCertificateMutationVariables) => fetcher<Types.UpdateHeatingCertificateMutation, Types.UpdateHeatingCertificateMutationVariables>(UpdateHeatingCertificateDocument, variables)(),
      options
    );
useUpdateHeatingCertificateMutation.fetcher = (variables: Types.UpdateHeatingCertificateMutationVariables, options?: RequestInit['headers']) => fetcher<Types.UpdateHeatingCertificateMutation, Types.UpdateHeatingCertificateMutationVariables>(UpdateHeatingCertificateDocument, variables, options);
export const UpdateInsuranceMultiriskUnitDocument = `
    mutation updateInsuranceMultiriskUnit($customerId: ID!, $insuranceMultiriskUnit: UpdateLeaseInsuranceMultiriskUnitInput!) {
  updateInsuranceMultiriskUnit(
    customerId: $customerId
    insuranceMultiriskUnit: $insuranceMultiriskUnit
  )
}
    `;
export const useUpdateInsuranceMultiriskUnitMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.UpdateInsuranceMultiriskUnitMutation, TError, Types.UpdateInsuranceMultiriskUnitMutationVariables, TContext>) =>
    useMutation<Types.UpdateInsuranceMultiriskUnitMutation, TError, Types.UpdateInsuranceMultiriskUnitMutationVariables, TContext>(
      ['updateInsuranceMultiriskUnit'],
      (variables?: Types.UpdateInsuranceMultiriskUnitMutationVariables) => fetcher<Types.UpdateInsuranceMultiriskUnitMutation, Types.UpdateInsuranceMultiriskUnitMutationVariables>(UpdateInsuranceMultiriskUnitDocument, variables)(),
      options
    );
useUpdateInsuranceMultiriskUnitMutation.fetcher = (variables: Types.UpdateInsuranceMultiriskUnitMutationVariables, options?: RequestInit['headers']) => fetcher<Types.UpdateInsuranceMultiriskUnitMutation, Types.UpdateInsuranceMultiriskUnitMutationVariables>(UpdateInsuranceMultiriskUnitDocument, variables, options);
export const GetLeasesDocument = `
    query GetLeases($filters: LeasesFiltersInput!, $cursor: CursorInput) {
  leases(filters: $filters, cursor: $cursor) {
    edges {
      node {
        id
        entryDate
        leaveDate
        tenants {
          isMain
          customer {
            id
            ... on CustomerPerson {
              lastName
              firstName
            }
            ... on CustomerCompany {
              companyName
            }
          }
        }
        units {
          isMain
          unit {
            coOwnershipBylawsId
            ... on UnitHousing {
              subType
            }
            ... on UnitApartment {
              subType
            }
            ... on UnitParking {
              category
            }
            ... on UnitProfessionalRetailer {
              category
            }
            ... on UnitLand {
              category
            }
            ... on UnitOther {
              category
            }
            ... on UnitIslet {
              category
            }
          }
        }
        building {
          address {
            address1
            zipCode
            city
            country
          }
        }
        tenantBalance {
          value
          currency
        }
      }
    }
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const useGetLeasesQuery = <
      TData = Types.GetLeasesQuery,
      TError = ServerError
    >(
      variables: Types.GetLeasesQueryVariables,
      options?: UseQueryOptions<Types.GetLeasesQuery, TError, TData>
    ) =>
    useQuery<Types.GetLeasesQuery, TError, TData>(
      ['GetLeases', variables],
      fetcher<Types.GetLeasesQuery, Types.GetLeasesQueryVariables>(GetLeasesDocument, variables),
      options
    );

useGetLeasesQuery.getKey = (variables: Types.GetLeasesQueryVariables) => ['GetLeases', variables];
;

export const useInfiniteGetLeasesQuery = <
      TData = Types.GetLeasesQuery,
      TError = ServerError
    >(
      variables: Types.GetLeasesQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetLeasesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetLeasesQuery, TError, TData>(
      ['GetLeases.infinite', variables],
      (metaData) => fetcher<Types.GetLeasesQuery, Types.GetLeasesQueryVariables>(GetLeasesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetLeasesQuery.getKey = (variables: Types.GetLeasesQueryVariables) => ['GetLeases.infinite', variables];
;

useGetLeasesQuery.fetcher = (variables: Types.GetLeasesQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetLeasesQuery, Types.GetLeasesQueryVariables>(GetLeasesDocument, variables, options);
export const GetRentalSituationFileDocument = `
    query GetRentalSituationFile($lessorAccountId: ID!) {
  rentalSituationFile(lessorAccountId: $lessorAccountId) {
    fileId
  }
}
    `;
export const useGetRentalSituationFileQuery = <
      TData = Types.GetRentalSituationFileQuery,
      TError = ServerError
    >(
      variables: Types.GetRentalSituationFileQueryVariables,
      options?: UseQueryOptions<Types.GetRentalSituationFileQuery, TError, TData>
    ) =>
    useQuery<Types.GetRentalSituationFileQuery, TError, TData>(
      ['GetRentalSituationFile', variables],
      fetcher<Types.GetRentalSituationFileQuery, Types.GetRentalSituationFileQueryVariables>(GetRentalSituationFileDocument, variables),
      options
    );

useGetRentalSituationFileQuery.getKey = (variables: Types.GetRentalSituationFileQueryVariables) => ['GetRentalSituationFile', variables];
;

export const useInfiniteGetRentalSituationFileQuery = <
      TData = Types.GetRentalSituationFileQuery,
      TError = ServerError
    >(
      variables: Types.GetRentalSituationFileQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetRentalSituationFileQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetRentalSituationFileQuery, TError, TData>(
      ['GetRentalSituationFile.infinite', variables],
      (metaData) => fetcher<Types.GetRentalSituationFileQuery, Types.GetRentalSituationFileQueryVariables>(GetRentalSituationFileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetRentalSituationFileQuery.getKey = (variables: Types.GetRentalSituationFileQueryVariables) => ['GetRentalSituationFile.infinite', variables];
;

useGetRentalSituationFileQuery.fetcher = (variables: Types.GetRentalSituationFileQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetRentalSituationFileQuery, Types.GetRentalSituationFileQueryVariables>(GetRentalSituationFileDocument, variables, options);